import Link from "next/link";
import React from "react";
import Image from "next/image";
import HeadLine from "../../components/headLine";
const SponsoredFacilities = ({
  facilities
}) => {
  const availableSpot = {
    profilePicUrl: '/images/trainers/no-pic.jpeg',
    title: 'Open Spot',
    trainers: 'Claim this spot, click for details',
    url: '/apps/training-facilities/become-featured'
  };
  const sponsoredFacilities = [];
  for (let index = 0; index < 9; index++) {
    const item = (facilities ?? []).find(x => x.featuredSpot === index);
    if (item) {
      sponsoredFacilities.push(item);
    } else {
      sponsoredFacilities.push({
        ...availableSpot,
        id: index
      });
    }
  }
  const renderFeatured = ({
    id,
    title,
    profilePicUrl,
    trainers,
    url
  }) => {
    return <article key={id} data-sentry-component="renderFeatured" data-sentry-source-file="SponsoredFacilities.jsx">
        <div className="relative overflow-hidden rounded-2.5xl bg-white dark:bg-jacarta-700">
          <figure className="relative">
            <Link href={url} className="group block after:absolute after:inset-0 after:block after:bg-jacarta-900/20" data-sentry-element="Link" data-sentry-source-file="SponsoredFacilities.jsx">
              <Image width={470} height={470} src={profilePicUrl} alt={title} className="w-full object-cover transition-transform duration-[1600ms] will-change-transform group-hover:scale-105" data-sentry-element="Image" data-sentry-source-file="SponsoredFacilities.jsx" />
            </Link>
          </figure>
          <div className="pointer-events-none absolute bottom-0 w-full p-5" style={{
          background: 'rgba(0,0,0,.45)'
        }}>
            <h2 className="font-display text-base leading-none text-white xl:text-lg">
              {title}
            </h2>
            <p className="text-2xs text-white">
              {trainers}
            </p>
          </div>
        </div>
      </article>;
  };
  return <>
      {/* <!-- Hero --> */}
      <section className="relative px-6 pb-8 py-24 md:pt-32">
      <HeadLine image="https://cdn.jsdelivr.net/npm/emoji-datasource-apple@7.0.2/img/apple/64/2764-fe0f.png" text="Sponsored Motocross Training Facilities" classes="font-display text-jacarta-700 mb-8 text-center text-3xl dark:text-white" data-sentry-element="HeadLine" data-sentry-source-file="SponsoredFacilities.jsx" />
        <div className="flex flex-col gap-5 lg:flex-row">
          {/* <div className="w-full lg:w-1/3">
            <div className="grid grid-cols-2 grid-rows-2 gap-5">
              {sponsoredFacilities.slice(0, 4).map((item) => {
                return renderFeatured(item);
              })}
            </div>
           </div> */}
          <div className="w-full lg:w-1/3">
            {renderFeatured(sponsoredFacilities[1])}
          </div>
          <div className="w-full lg:w-1/3">
            {renderFeatured(sponsoredFacilities[4])}
          </div>
          <div className="w-full lg:w-1/3">
            {renderFeatured(sponsoredFacilities[0])}
          </div>
          {/* <div className="w-full lg:w-1/3">
            <div className="grid grid-cols-2 grid-rows-2 gap-5">
              {sponsoredFacilities.slice(5, 9).map((item) => {
                return renderFeatured(item);
              })}
            </div>
           </div> */}
        </div>
      </section>
    </>;
};
export default SponsoredFacilities;